import { openBlock as t, createElementBlock as l, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function a(n, e) {
  return t(), l("svg", r, [...e[0] || (e[0] = [
    o("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M11.568 2.742a.5.5 0 0 1 .864 0l2.69 4.618a.5.5 0 0 0 .326.237l5.224 1.131a.5.5 0 0 1 .267.822l-3.561 3.985a.5.5 0 0 0-.125.384l.538 5.317a.5.5 0 0 1-.699.508l-4.89-2.155a.5.5 0 0 0-.404 0l-4.89 2.155a.5.5 0 0 1-.7-.508l.539-5.317a.5.5 0 0 0-.125-.384L3.062 9.55a.5.5 0 0 1 .266-.822l5.224-1.131a.5.5 0 0 0 .326-.237z"
    }, null, -1)
  ])]);
}
const c = { render: a };
export {
  c as default,
  a as render
};
